import _ from 'lodash'
import { v4 as uuid } from 'uuid';
import React from 'react';

import {
  Category,
  ExternalGuideline,
  Guideline,
  HomePage,
  HomeGuidelineLink,
  Footer,
  FooterLink,
  FooterText,
  Subcategory,
  Topic,
} from './../store/contentTypes'

import ComponentDataFactory from './../store/contentTypes/componentDataTypes/ComponentDataFactory'

import COMPONENT_CONSTANTS from './../store/contentTypes/componentDataTypes/COMPONENT_CONSTANTS'

import STORE_CONSTANTS from './../store/STORE_CONSTANTS'
import { Micro } from 'components';

const placeholderImageURL =
  'data:image/png;base64,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'

class DataParser {
  parseGuidelineEntries(guidelineEntries) {
    const guidelines = []

    _.each(guidelineEntries, guidelineData => {
      if (!_.has(guidelineData.fields, 'categories')) return
      else if (guidelineData.fields.categories.length === 0) return

      const guideline = {
        id: guidelineData.sys.id,
        type: 'onpage',
        title: guidelineData.fields.title
          ? guidelineData.fields.title
          : 'TITLE MISSING',
        urlSlug: guidelineData.fields.urlSlug
          ? guidelineData.fields.urlSlug
          : 'URL_SLUG_MISSING_' + uuid(),
        categories: [],
        dropdownPriority: guidelineData.fields.dropdownPriority
          ? guidelineData.fields.dropdownPriority
          : 999,
        theme: guidelineData.fields.theme,
        excludeFromNav: guidelineData.fields.excludeFromNav ? guidelineData.fields.excludeFromNav : false,
      }

      _.each(guidelineData.fields.categories, categoryData => {
        if (!_.has(categoryData, 'fields')) return

        const category = {
          id: categoryData.sys.id,
          title: categoryData.fields.title
            ? categoryData.fields.title
            : 'TITLE MISSING',
          urlSlug: categoryData.fields.urlSlug
            ? categoryData.fields.urlSlug
            : 'URL_SLUG_MISSING_' + uuid(),
          subcategories: [],
        }

        if (!_.has(categoryData.fields, 'subcategories')) return
        else if (categoryData.fields.subcategories.length === 0) return

        _.each(categoryData.fields.subcategories, subcategoryData => {
          if (!_.has(subcategoryData, 'fields')) return

          const subcategory = {
            id: subcategoryData.sys.id,
            title: subcategoryData.fields.title
              ? subcategoryData.fields.title
              : 'TITLE MISSING',
            urlSlug: subcategoryData.fields.urlSlug
              ? subcategoryData.fields.urlSlug
              : 'urlSlugMissing',
            searchKeywords: subcategoryData.fields.searchKeywords
              ? subcategoryData.fields.searchKeywords
              : [],
            components: [],
            sidenavSubnavLinks: [],
          }

          if (_.has(subcategoryData.fields, 'sidenavSubnavLinks')) {
            _.each(subcategoryData.fields.sidenavSubnavLinks, link => {
              if (_.has(link, 'fields') && _.has(link.fields, 'anchorSlug')) {
                subcategory.sidenavSubnavLinks.push({
                  id: link.sys.id,
                  title: link.fields.title,
                  anchorSlug: link.fields.anchorSlug,
                })
              }
            })
          }

          _.each(subcategoryData.fields.components, componentData => {
            const component = this.parseComponent(componentData)

            if (component) subcategory.components.push(component)
          })

          category.subcategories.push(new Subcategory(subcategory))
        })

        guideline.categories.push(new Category(category))
      })

      if(!guideline.excludeFromNav) {
        guidelines.push(new Guideline(guideline))
      }

    })

    return guidelines
  }

  parseComponent(componentData) {
    if (!_.has(componentData, 'fields')) return null

    const component = {
      id: componentData.sys.id,
      additionalPaddingBelowComponent: componentData.fields
        .additionalPaddingBelowComponent
        ? componentData.fields.additionalPaddingBelowComponent
        : false,
    }

    switch (componentData.sys.contentType.sys.id) {
      case COMPONENT_CONSTANTS.TYPES.HERO:
        component.type = COMPONENT_CONSTANTS.TYPES.HERO
        component.title = componentData.fields.title
        component.updatedCopy = _.get(componentData.fields, 'updatedCopy', null)
        component.buttonsCopy = _.get(componentData.fields, 'buttonsCopy', null)
        component.CTAButtons = []
        component.theme = componentData.fields.theme
          ? componentData.fields.theme
          : 'Black_BG'

        if (_.has(componentData.fields, 'CTAButtons')) {
          _.each(componentData.fields.CTAButtons, CTAButton => {
            if (
              _.has(CTAButton, 'fields') &&
              _.has(CTAButton.fields, 'title') &&
              _.has(CTAButton.fields, 'type') &&
              _.has(CTAButton.fields, 'url')
            ) {
              component.CTAButtons.push({
                id: CTAButton.sys.id,
                title: CTAButton.fields.title,
                type: CTAButton.fields.type,
                url: CTAButton.fields.url,
              })
            }
          })
        }

        break

      case COMPONENT_CONSTANTS.TYPES.CONTAINER_INVERT_THEME_TO_DARK:
        component.type =
          COMPONENT_CONSTANTS.TYPES.CONTAINER_INVERT_THEME_TO_DARK
        component.components = []

        _.each(componentData.fields.components, componentData => {
          let parsedComponentData

          parsedComponentData = this.parseComponent(componentData)

          if (parsedComponentData)
            component.components.push(parsedComponentData)
        })

        break

      case COMPONENT_CONSTANTS.TYPES.SECTION_HEADER:
        component.type = COMPONENT_CONSTANTS.TYPES.SECTION_HEADER
        component.title = componentData.fields.title
        component.description = componentData.fields.description
        component.CTAButtons = []
        component.anchorLinkTarget = componentData.fields.anchorLinkTarget
          ? componentData.fields.anchorLinkTarget
          : null

        if (_.has(componentData.fields, 'CTAButtons')) {
          _.each(componentData.fields.CTAButtons, CTAButton => {
            if (
              _.has(CTAButton, 'fields') &&
              _.has(CTAButton.fields, 'title') &&
              _.has(CTAButton.fields, 'type') &&
              _.has(CTAButton.fields, 'url')
            ) {
              component.CTAButtons.push({
                id: CTAButton.sys.id,
                title: CTAButton.fields.title,
                type: CTAButton.fields.type,
                url: CTAButton.fields.url,
              })
            } else if (
              CTAButton.sys.contentType.sys.id ===
              COMPONENT_CONSTANTS.TYPES.VZBUTTON
            ) {
              component.CTAButtons.push(this.parseComponent(CTAButton))
            }
          })
        }

        break

      case COMPONENT_CONSTANTS.TYPES.INTER_SECTION_HEADER:
        component.type = COMPONENT_CONSTANTS.TYPES.INTER_SECTION_HEADER
        component.title = componentData.fields.title
        component.titleSize = componentData.fields.titleSize
          ? componentData.fields.titleSize
          : 'intro'
        component.typographyID = _.get(
          componentData.fields,
          'typography.fields.id',
          null,
        )
        component.description = componentData.fields.description
          ? componentData.fields.description
          : null
        component.CTAButtons = []
        component.anchorLinkTarget = componentData.fields.anchorLinkTarget
          ? componentData.fields.anchorLinkTarget
          : null
        component.headerStyle = componentData.fields.headerStyle
          ? componentData.fields.headerStyle
          : 'Black 2px'

        if (_.has(componentData.fields, 'CTAButtons')) {
          _.each(componentData.fields.CTAButtons, CTAButton => {
            if (
              _.has(CTAButton, 'fields') &&
              _.has(CTAButton.fields, 'title') &&
              _.has(CTAButton.fields, 'type') &&
              _.has(CTAButton.fields, 'url')
            ) {
              component.CTAButtons.push({
                id: CTAButton.sys.id,
                title: CTAButton.fields.title,
                type: CTAButton.fields.type,
                url: CTAButton.fields.url,
              })
            }
          })
        }

        break

      case COMPONENT_CONSTANTS.TYPES.GRID_50_50:
      case COMPONENT_CONSTANTS.TYPES.GRID_25_75:
      case COMPONENT_CONSTANTS.TYPES.GRID_75_25:
        component.type = componentData.sys.contentType.sys.id
        component.leftSide = []
        component.rightSide = []

        _.each(componentData.fields.leftSide, leftSideData => {
          component.leftSide.push(this.parseComponent(leftSideData))
        })

        _.each(componentData.fields.rightSide, rightSideData => {
          component.rightSide.push(this.parseComponent(rightSideData))
        })

        break

      case COMPONENT_CONSTANTS.TYPES.GRID_33_33_33:
        component.type = componentData.sys.contentType.sys.id
        component.leftSide = []
        component.middle = []
        component.rightSide = []

        _.each(componentData.fields.leftSide, leftSideData => {
          component.leftSide.push(this.parseComponent(leftSideData))
        })

        _.each(componentData.fields.middle, middleData => {
          component.middle.push(this.parseComponent(middleData))
        })

        _.each(componentData.fields.rightSide, rightSideData => {
          component.rightSide.push(this.parseComponent(rightSideData))
        })

        break

      case COMPONENT_CONSTANTS.TYPES.GRID_5UP:
        component.type = componentData.sys.contentType.sys.id
        component.column1 = []
        component.column2 = []
        component.column3 = []
        component.column4 = []
        component.column5 = []

        _.each(componentData.fields.column1, column1Data => {
          component.column1.push(this.parseComponent(column1Data))
        })

        _.each(componentData.fields.column2, column2Data => {
          component.column2.push(this.parseComponent(column2Data))
        })

        _.each(componentData.fields.column3, column3Data => {
          component.column3.push(this.parseComponent(column3Data))
        })

        _.each(componentData.fields.column4, column4Data => {
          component.column4.push(this.parseComponent(column4Data))
        })

        _.each(componentData.fields.column5, column5Data => {
          component.column5.push(this.parseComponent(column5Data))
        })

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'alt')
        )
          component.alt = componentData.fields.alt
        else component.alt = ''

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'srcLarge') &&
          _.has(componentData.fields.srcLarge.fields, 'file') &&
          _.has(componentData.fields.srcLarge.fields.file, 'url') &&
          _.has(componentData.fields.srcLarge.fields.file, 'details')
        ) {
          component.srcLarge = componentData.fields.srcLarge.fields.file.url
          component.largeWidth =
            componentData.fields.srcLarge.fields.file.details.image.width
          component.largeHeight =
            componentData.fields.srcLarge.fields.file.details.image.height
        } else {
          component.srcLarge = placeholderImageURL
          component.largeWidth = '400'
          component.largeHeight = '200'
        }

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'srcSmall') &&
          _.has(componentData.fields.srcSmall.fields, 'file') &&
          _.has(componentData.fields.srcSmall.fields.file, 'url') &&
          _.has(componentData.fields.srcSmall.fields.file, 'details')
        ) {
          component.srcSmall = componentData.fields.srcSmall.fields.file.url
          component.smallWidth =
            componentData.fields.srcSmall.fields.file.details.image.width
          component.smallHeight =
            componentData.fields.srcSmall.fields.file.details.image.height
        } else {
          component.srcSmall = component.srcLarge
          component.smallWidth = component.largeWidth
          component.smallHeight = component.largeHeight
        }

        component.caption = componentData.fields.caption
          ? componentData.fields.caption
          : null
        component.lineColor = componentData.fields.lineColor
          ? componentData.fields.lineColor
          : null

        break

      case COMPONENT_CONSTANTS.TYPES.LINK_IMAGE:
        component.type = COMPONENT_CONSTANTS.TYPES.LINK_IMAGE
        component.title = componentData.fields.title
          ? componentData.fields.title
          : null
        component.titleSize = componentData.fields.titleSize
          ? componentData.fields.titleSize
          : 'intro'
        component.description = componentData.fields.description
          ? componentData.fields.description
          : null
        component.url = componentData.fields.url
          ? componentData.fields.url
          : '/'
        component.linkType = componentData.fields.linkType
        component.image = this.parseComponent(componentData.fields.image)

        break

      case COMPONENT_CONSTANTS.TYPES.SECTION_FOOTER:
        component.type = COMPONENT_CONSTANTS.TYPES.SECTION_FOOTER
        component.text = componentData.fields.text

        break

      case COMPONENT_CONSTANTS.TYPES.CAUTION_HEADER:
        component.type = COMPONENT_CONSTANTS.TYPES.CAUTION_HEADER
        component.title = componentData.fields.title

        break

      case COMPONENT_CONSTANTS.TYPES.DO_HEADER:
        component.type = COMPONENT_CONSTANTS.TYPES.DO_HEADER
        component.title = componentData.fields.title
        component.removeBottomPadding = componentData.fields.removeBottomPadding

        break

      case COMPONENT_CONSTANTS.TYPES.DONT_HEADER:
        component.type = COMPONENT_CONSTANTS.TYPES.DONT_HEADER
        component.title = componentData.fields.title
        component.removeBottomPadding = componentData.fields.removeBottomPadding

        break

      case COMPONENT_CONSTANTS.TYPES.TEXT_BLOCK:
        component.type = COMPONENT_CONSTANTS.TYPES.TEXT_BLOCK
        component.text = componentData.fields.text
        component.textSize = componentData.fields.textSize
          ? componentData.fields.textSize
          : 'intro'
        component.removePadding = componentData.fields.removePadding

        break

      case COMPONENT_CONSTANTS.TYPES.COLOR_SWATCH:
        component.type = COMPONENT_CONSTANTS.TYPES.COLOR_SWATCH
        component.colorHex = componentData.fields.colorHex
        component.borderColor = componentData.fields.borderColor
        component.roundBorders = componentData.fields.roundBorders
        component.squareSwatch = componentData.fields.squareSwatch

        break

      case COMPONENT_CONSTANTS.TYPES.FLEX_GRID:
        component.type = COMPONENT_CONSTANTS.TYPES.FLEX_GRID
        component.header = []
        component.columns = []

        _.each(componentData.fields.header, headerData => {
          component.header.push(this.parseComponent(headerData))
        })

        _.each(componentData.fields.columns, columnData => {
          component.columns.push(this.parseComponent(columnData))
        })

        break

      case COMPONENT_CONSTANTS.TYPES.FLEX_GRID_COLUMN:
        component.type = COMPONENT_CONSTANTS.TYPES.FLEX_GRID_COLUMN
        component.content = []
        component.textAlignment = componentData.fields.textAlignment
        component.dynamicWidth = componentData.fields.dynamicWidth
        component.fullWidth = componentData.fields.fullWidth

        _.each(componentData.fields.content, contentData => {
          component.content.push(this.parseComponent(contentData))
        })

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_1:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_1
        component.alt = componentData.fields.altText
        component.images = []

        _.each(componentData.fields.images, image => {
          if (
            _.has(image, 'fields') &&
            _.has(image.fields, 'file') &&
            _.has(image.fields.file, 'url')
          )
            component.images.push(image.fields.file.url)
          else component.images.push(placeholderImageURL)
        })

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_2:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_2
        component.alt = componentData.fields.altText

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'leftSquareImage') &&
          _.has(componentData.fields.leftSquareImage, 'fields') &&
          _.has(componentData.fields.leftSquareImage.fields, 'file') &&
          _.has(componentData.fields.leftSquareImage.fields.file, 'url')
        )
          component.leftSquareImage =
            componentData.fields.leftSquareImage.fields.file.url
        else component.leftSquareImage = placeholderImageURL

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightUpperRectangularImage') &&
          _.has(componentData.fields.rightUpperRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields.file,
            'url',
          )
        )
          component.rightUpperRectangularImage =
            componentData.fields.rightUpperRectangularImage.fields.file.url
        else component.rightUpperRectangularImage = placeholderImageURL

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightLowerRectangularImage') &&
          _.has(componentData.fields.rightLowerRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields.file,
            'url',
          )
        )
          component.rightLowerRectangularImage =
            componentData.fields.rightLowerRectangularImage.fields.file.url
        else component.rightLowerRectangularImage = placeholderImageURL

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_3:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_3
        component.alt = componentData.fields.altText

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'leftUpperRectangularImage') &&
          _.has(componentData.fields.leftUpperRectangularImage, 'fields') &&
          _.has(
            componentData.fields.leftUpperRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.leftUpperRectangularImage.fields.file,
            'url',
          )
        )
          component.leftUpperRectangularImage =
            componentData.fields.leftUpperRectangularImage.fields.file.url
        else component.leftUpperRectangularImage = placeholderImageURL

        component.leftLowerSquareImages = []

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightUpperRectangularImage') &&
          _.has(componentData.fields.rightUpperRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields.file,
            'url',
          )
        )
          component.rightUpperRectangularImage =
            componentData.fields.rightUpperRectangularImage.fields.file.url
        else component.rightUpperRectangularImage = placeholderImageURL

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightLowerRectangularImage') &&
          _.has(componentData.fields.rightLowerRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields.file,
            'url',
          )
        )
          component.rightLowerRectangularImage =
            componentData.fields.rightLowerRectangularImage.fields.file.url
        else component.rightLowerRectangularImage = placeholderImageURL

        _.each(componentData.fields.leftLowerSquareImages, image => {
          if (
            _.has(image, 'fields') &&
            _.has(image.fields, 'file') &&
            _.has(image.fields.file, 'url')
          )
            component.leftLowerSquareImages.push(image.fields.file.url)
          else component.leftLowerSquareImages.push(placeholderImageURL)
        })

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_4:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_4
        component.alt = componentData.fields.altText

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'leftUpperRectangularImage') &&
          _.has(componentData.fields.leftUpperRectangularImage, 'fields') &&
          _.has(
            componentData.fields.leftUpperRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.leftUpperRectangularImage.fields.file,
            'url',
          )
        )
          component.leftUpperRectangularImage =
            componentData.fields.leftUpperRectangularImage.fields.file.url
        else component.leftUpperRectangularImage = placeholderImageURL

        component.leftLowerSquareImages = []
        component.rightUpperSquareImages = []

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightLowerRectangularImage') &&
          _.has(componentData.fields.rightLowerRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightLowerRectangularImage.fields.file,
            'url',
          )
        )
          component.rightLowerRectangularImage =
            componentData.fields.rightLowerRectangularImage.fields.file.url
        else component.rightLowerRectangularImage = placeholderImageURL

        _.each(componentData.fields.leftLowerSquareImages, image => {
          if (
            _.has(image, 'fields') &&
            _.has(image.fields, 'file') &&
            _.has(image.fields.file, 'url')
          )
            component.leftLowerSquareImages.push(image.fields.file.url)
          else component.leftLowerSquareImages.push(placeholderImageURL)
        })

        _.each(componentData.fields.rightUpperSquareImages, image => {
          if (
            _.has(image, 'fields') &&
            _.has(image.fields, 'file') &&
            _.has(image.fields.file, 'url')
          )
            component.rightUpperSquareImages.push(image.fields.file.url)
          else component.rightUpperSquareImages.push(placeholderImageURL)
        })

        break

      case COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_5:
        component.type = COMPONENT_CONSTANTS.TYPES.IMAGE_GRID_VERSION_5
        component.alt = componentData.fields.altText

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'leftSquareImage') &&
          _.has(componentData.fields.leftSquareImage, 'fields') &&
          _.has(componentData.fields.leftSquareImage.fields, 'file') &&
          _.has(componentData.fields.leftSquareImage.fields.file, 'url')
        )
          component.leftSquareImage =
            componentData.fields.leftSquareImage.fields.file.url
        else component.leftSquareImage = placeholderImageURL

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'rightUpperRectangularImage') &&
          _.has(componentData.fields.rightUpperRectangularImage, 'fields') &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields,
            'file',
          ) &&
          _.has(
            componentData.fields.rightUpperRectangularImage.fields.file,
            'url',
          )
        )
          component.rightUpperRectangularImage =
            componentData.fields.rightUpperRectangularImage.fields.file.url
        else component.rightUpperRectangularImage = placeholderImageURL

        component.rightLowerSquareImages = []

        _.each(componentData.fields.rightLowerSquareImages, image => {
          if (
            _.has(image, 'fields') &&
            _.has(image.fields, 'file') &&
            _.has(image.fields.file, 'url')
          )
            component.rightLowerSquareImages.push(image.fields.file.url)
          else component.rightLowerSquareImages.push(placeholderImageURL)
        })

        break

      case COMPONENT_CONSTANTS.TYPES.TABLE:
        if (
          !_.has(componentData, 'fields') ||
          !_.has(componentData.fields, 'tableHeader') ||
          !_.has(componentData.fields.tableHeader, 'sys') ||
          !_.has(componentData.fields.tableHeader, 'fields') ||
          !_.has(componentData.fields.tableHeader.fields, 'cells') ||
          !_.has(componentData.fields, 'tableRows')
        )
          return null

        component.type = COMPONENT_CONSTANTS.TYPES.TABLE

        const headerCells = []

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'tableHeader') &&
          _.has(componentData.fields.tableHeader, 'sys') &&
          _.has(componentData.fields.tableHeader, 'fields') &&
          _.has(componentData.fields.tableHeader.fields, 'cells')
        )
          _.each(componentData.fields.tableHeader.fields.cells, cell => {
            headerCells.push({
              id: cell.sys.id,
              content: cell.fields.content,
            })
          })

        component.header = {
          id: componentData.fields.tableHeader.sys.id,
          cells: headerCells,
        }

        const tableRows = []

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'tableRows')
        )
          _.each(componentData.fields.tableRows, row => {
            const cells = []

            if (_.has(row, 'fields') && _.has(row.fields, 'cells'))
              _.each(row.fields.cells, cell => {
                cells.push({
                  id: cell.sys.id,
                  content: cell.fields.content,
                })
              })

            tableRows.push({
              id: row.sys.id,
              cells,
            })
          })

        component.tableRows = tableRows

        component.description = componentData.fields.description
          ? componentData.fields.description
          : null

        break

      case COMPONENT_CONSTANTS.TYPES.ANIMATION:
        component.type = COMPONENT_CONSTANTS.TYPES.ANIMATION
        component.largeVideo = componentData.fields.largeVideo.fields.file.url
        component.largePoster = componentData.fields.largeVideoPoster
          ? componentData.fields.largeVideoPoster.fields.file.url
          : null
        component.smallVideo = componentData.fields.smallVideo
          ? componentData.fields.smallVideo.fields.file.url
          : null
        component.smallPoster = componentData.fields.smallVideoPoster
          ? componentData.fields.smallVideoPoster.fields.file.url
          : componentData.fields.largeVideoPoster
          ? componentData.fields.largeVideoPoster.fields.file.url
          : null
        component.caption = componentData.fields.caption
          ? componentData.fields.caption
          : null
        component.playButtonColor = componentData.fields.playButtonColor
          ? componentData.fields.playButtonColor
          : 'black'
        component.lineColor = componentData.fields.lineColor
          ? componentData.fields.lineColor
          : null
        component.hasOptionalBorder = componentData.fields.hasOptionalBorder
          ? componentData.fields.hasOptionalBorder
          : false
        component.autoplay = componentData.fields.autoplay
          ? componentData.fields.autoplay
          : false

        break

      case COMPONENT_CONSTANTS.TYPES.ANIMATION_MOBILE_AND_DESKTOP_COMPARE:
        component.type =
          COMPONENT_CONSTANTS.TYPES.ANIMATION_MOBILE_AND_DESKTOP_COMPARE
        component.mobileAnimation = this.parseComponent(
          componentData.fields.mobileAnimation,
        )
        component.desktopAnimation = this.parseComponent(
          componentData.fields.desktopAnimation,
        )

        break

      case COMPONENT_CONSTANTS.TYPES.VIDEO_PLAYER:
        component.type = COMPONENT_CONSTANTS.TYPES.VIDEO_PLAYER
        component.video = componentData.fields.video

        if (
          _.has(componentData, 'fields') &&
          _.has(componentData.fields, 'poster') &&
          _.has(componentData.fields.poster, 'fields') &&
          _.has(componentData.fields.poster.fields, 'file') &&
          _.has(componentData.fields.poster.fields.file, 'url')
        )
          component.poster = componentData.fields.poster.fields.file.url
        else component.poster = placeholderImageURL

        component.paddingTop = _.get(componentData.fields, 'paddingTop', '2.5')
        component.hasBorder = _.get(componentData.fields, 'hasBorder', true)

        break

      case COMPONENT_CONSTANTS.TYPES.VZBUTTON:
        component.type = COMPONENT_CONSTANTS.TYPES.VZBUTTON
        component.label = _.get(componentData.fields, 'label', 'LABEL MISSING')
        component.action = _.get(
          componentData.fields,
          'action',
          'ACTION MISSING',
        )
        component.buttonType = _.get(
          componentData.fields,
          'buttonType',
          'standard',
        )
        component.style = _.get(componentData.fields, 'style', 'primary-black')

        break

      case COMPONENT_CONSTANTS.TYPES.CONTENT_BLOCK:
        component.type = COMPONENT_CONSTANTS.TYPES.CONTENT_BLOCK
        component.content = _.get(componentData.fields, 'content.content', [])
        component.defaultTypography = _.get(
          componentData.fields,
          'defaultTypography',
          null,
        )

        break

      case COMPONENT_CONSTANTS.TYPES.BEFORE_AND_AFTER:
        component.type = COMPONENT_CONSTANTS.TYPES.BEFORE_AND_AFTER
        component.isFullWidth = _.get(componentData.fields, 'isFullWidth', true)

        component.beforeToggleLabel = _.get(
          componentData.fields,
          'beforeToggleLabel',
          'BEFORE LABEL MISSING',
        )
        component.beforeDescription = _.get(
          componentData.fields,
          'beforeDescription',
          'BEFORE DESCRIPTION MISSING',
        )

        component.beforeImage = _.get(
          componentData.fields,
          'beforeImage.fields.file.url',
          placeholderImageURL,
        )

        component.beforeImageAltText = _.get(
          componentData.fields,
          'beforeImageAltText',
          'BEFORE IMAGE ALT TEXT MISSING',
        )

        component.afterToggleLabel = _.get(
          componentData.fields,
          'afterToggleLabel',
          'AFTER LABEL MISSING',
        )
        component.afterDescription = _.get(
          componentData.fields,
          'afterDescription',
          'AFTER DESCRIPTION MISSING',
        )

        component.afterImage = _.get(
          componentData.fields,
          'afterImage.fields.file.url',
          placeholderImageURL,
        )

        component.afterImageAltText = _.get(
          componentData.fields,
          'afterImageAltText',
          'AFTER IMAGE ALT TEXT MISSING',
        )

        component.additionalPaddingBelowComponent = _.get(
          componentData.fields,
          'additionalPaddingBelowComponent',
          false,
        )

        break

      default:
        return null
    }

    return ComponentDataFactory.parseComponentData(component)
  }

  parseExternalGuidelines(externalGuidelineEntries) {
    const externalGuidelines = []

    _.each(externalGuidelineEntries, externalGuidelineData => {
      const externalGuideline = {
        id: externalGuidelineData.sys.id,
        type: 'external',
        title: externalGuidelineData.fields.title,
        searchDescription: externalGuidelineData.fields.searchDescription,
        url: externalGuidelineData.fields.url,
      }

      externalGuidelines.push(new ExternalGuideline(externalGuideline))
    })

    return externalGuidelines
  }

  getEntryBySysID(entries, sysID) {
    return entries.filter(entry => entry.sys.id === sysID)[0]
  }

  parseDecisionTreeContent(rootData, optionsData, panelsData) {
    const decisionTree = rootData

    decisionTree.fields.options = this.getEntryBySysID(
      optionsData,
      decisionTree.fields.options.sys.id,
    )

    decisionTree.panels = panelsData

    return decisionTree
  }

  parseHomeGuidelineLink(entry) {
    return new HomeGuidelineLink({
      id: entry.sys.id,
      isNew: _.get(entry.fields, 'isNew', false),
      title: _.get(entry.fields, 'title', 'TITLE MISSING'),
      description: _.get(entry.fields, 'description', ''),
      ctaLabel: _.get(entry.fields, 'ctaLabel', 'CTA LABEL MISSING'),
      textColor: _.get(entry.fields, 'textColor', 'black'),
      url: _.get(entry.fields, 'url', 'URL MISSING'),
      linkType: _.get(entry.fields, 'linkType', 'external'),
      alt: _.get(entry.fields, 'alt', ''),
      largeSquareImage: _.get(
        entry.fields,
        'largeSquareImage.fields.file.url',
        null,
      ),
      smallSquareImage: _.get(
        entry.fields,
        'smallSquareImage.fields.file.url',
        null,
      ),
      video: _.get(entry.fields, 'video.fields.file.url', null),
      relatedTopics: _.get(entry.fields, 'relatedTopics', []).map(
        topic =>
          new Topic({
            id: topic.sys.id,
            name: _.get(topic.fields, 'name', 'NAME MISSING'),
            slug: _.get(topic.fields, 'slug', 'NAME MISSING'),
          }),
      ),
      primaryTopics: _.get(entry.fields, 'primaryTopics', []).map(
        topic =>
          new Topic({
            id: topic.sys.id,
            name: _.get(topic.fields, 'name', 'NAME MISSING'),
            slug: _.get(topic.fields, 'slug', 'NAME MISSING'),
          }),
      ),
    })
  }

  parseHomeContent(homePageEntry) {
    const masterbrandGuidelineLink = this.parseHomeGuidelineLink(
      homePageEntry.fields.masterbrandGuidelineLink,
    )

    const topics = _.get(homePageEntry.fields, 'topics', []).map(
      topic =>
        new Topic({
          id: topic.sys.id,
          name: _.get(topic.fields, 'name', 'NAME MISSING'),
          slug: _.get(topic.fields, 'slug', 'NAME MISSING'),
        }),
    )

    const guidelineLinks = _.get(
      homePageEntry.fields,
      'guidelineLinks',
      [],
    ).map(this.parseHomeGuidelineLink)

    const mainGuidelines = _.get(
      homePageEntry.fields,
      'mainGuidelines',
      [],
    ).map(this.parseHomeGuidelineLink)

    const homePage = new HomePage({
      id: homePageEntry.sys.id,
      header: _.get(homePageEntry.fields, 'header', 'HEADER MISSING'),
      subhead: _.get(homePageEntry.fields, 'subhead', 'SUBHEAD MISSING'),
      masterbrandGuidelineLink,
      topics,
      guidelineLinks: guidelineLinks,
      mainGuidelines: mainGuidelines,
      seeMoreLabel: _.get(
        homePageEntry.fields,
        'seeMoreLabel',
        'SEE MORE LABEL MISSING',
      ),
      seeLessLabel: _.get(
        homePageEntry.fields,
        'seeLessLabel',
        'SEE LESS LABEL MISSING',
      ),
    })

    return homePage
  }

  parseFooterContent(footerEntries) {
    const items = []

    _.each(footerEntries[0].fields.items, item => {
      if (
        item.sys.contentType.sys.id ===
        STORE_CONSTANTS.CONTENT.TYPES.FOOTER_LINK
      ) {
        items.push(
          new FooterLink({
            id: item.sys.id,
            title: item.fields.title,
            type: item.fields.type,
            url: item.fields.url,
          }),
        )
      } else if (
        item.sys.contentType.sys.id ===
        STORE_CONSTANTS.CONTENT.TYPES.FOOTER_TEXT
      ) {
        items.push(
          new FooterText({
            id: item.sys.id,
            title: <Micro color="#ffffff">&copy; {new Date().getFullYear()} Verizon</Micro>,
          }),
        )
      }
    })

    return new Footer({
      id: footerEntries[0].sys.id,
      items,
    })
  }
}

const dataParser = new DataParser()

export default dataParser
